import type { OBB } from '../../geo/types';
import type { Lot } from './types';
import { lotFrame } from './lotFrame';

/**
 * A building across the plot from `from` to `to` metres behind the house, as wide as `share` of it,
 * its middle `shift` metres along the house's axis from the plot's middle.
 */
export function across(house: Lot, from: number, to: number, share: number, shift = 0): OBB {
  const { frontMid, facing, width, depth } = lotFrame(house);
  const middle = depth + (from + to) / 2;
  const [ax, ay] = house.obb.axisU;
  return {
    center: [
      frontMid[0] - facing[0] * middle + ax * shift,
      frontMid[1] - facing[1] * middle + ay * shift,
    ],
    axisU: house.obb.axisU,
    halfU: (width * share) / 2,
    halfV: (to - from) / 2,
  };
}
